import styled from "styled-components";

export const Styled = {
    Wrapper: styled.div`
        /* border: 1px solid #f00; */
        margin-top: 30px;
    `,
};

export const Header = styled.div`
    /* border: 1px solid #f00; */

    .row1 {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .heading_text {
            letter-spacing: -0.025em;
            line-height: 1;
            font-weight: 600;
            font-size: 1.5rem;
            line-height: 2rem;
            color: var(--primary-text-color);
        }

        .add_video {
            background-color: hsl(265 89% 60% / var(--tw-bg-opacity, 1));
            color: #fff;

            &:hover {
                background-color: hsl(265 89% 60% / 0.9);
            }
        }
    }

    .row2 {
        color: var(--secondary-text-color);

        font-size: 0.875rem;
        line-height: 1.25rem;
    }
`;

export const ControlsSection = styled.div`
    /* border: 1px solid #f00; */
    margin-top: 15px;
    display: flex;
    align-items: stretch;
    gap: 15px;

    .search_wrapper {
        width: 100%;
        position: relative;
        border: 1px solid var(--border-color);
        border-radius: 5px;
        overflow: hidden;
        display: flex;
        align-items: center;

        .icon_wrapper {
            /* border: 1px solid #f00; */
            width: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: var(--primary-text-color);
        }

        input {
            width: 100%;
            border: none;
            outline: none;
            padding: 5px;
            background-color: transparent;
            color: var(--secondary-text-color);
        }
    }

    .filter {
        /* width: 100px; */
        border: 1px solid var(--border-color);
        padding: 0 15px;
        display: flex;
        align-items: center;
        gap: 10px;
        border-radius: 5px;
        cursor: pointer;
        color: var(--secondary-text-color);
    }

    .export {
        border: 1px solid var(--border-color);
        padding: 0 15px;
        display: flex;
        align-items: center;
        gap: 10px;
        border-radius: 5px;
        cursor: pointer;
        color: var(--secondary-text-color);
    }
`;

export const VideoSlider = styled.div`
    margin-top: 30px;

    .slick-slide {
        padding: 0 10px;
        box-sizing: border-box;
    }

    .slick-list {
        margin: 0 -10px;
    }

    .card {
        border: 1px solid var(--border-color);
        border-radius: 12px;
        text-align: left;
        height: 100%;
        overflow: hidden;
    }

    .video {
        width: 100%;
        height: 250px;

        video {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .text_wrapper {
        padding: 20px;
        /* backdrop-filter: blur(3px);
        -webkit-backdrop-filter: blur(3px); */
        position: relative;
    }

    .title {
        font-size: 1.1rem;
        margin: 10px 0;
        color: var(--primary-text-color);
    }

    .author_posiiton_wrapper {
        display: flex;
        align-items: center;
        gap: 5px;

        .author {
            color: #888;
            font-size: 0.9rem;
        }
        .position {
            color: #888;
            font-size: 0.9rem;
        }
    }

    .rating_views_wrapper {
        display: flex;
        justify-content: space-between;
        margin-top: 5px;

        .rating {
            color: var(--primary-text-color);
            font-weight: bold;
        }
        .views {
            color: rgba(0, 0, 0, 0.3);
            color: var(--secondary-text-color);
        }
    }

    hr {
        background-color: rgba(0, 0, 0, 0.3);
    }

    .review_section {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        gap: 8px;

        .review {
            font-size: 0.85rem;
            color: #333;
            line-height: 1.4;
        }

        .reviewer_name {
            font-weight: 600;
            color: #000;
            font-size: 0.9rem;
            display: flex;
            justify-content: space-between;
            color: var(--primary-text-color);

            .rating {
            }
        }

        .review_text {
            margin-left: 5px;
            color: var(--secondary-text-color);
        }
    }

    .preview_control_wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 15px;

        .previewButton {
            padding: 8px 12px;
            border-radius: 6px;
            cursor: pointer;
            border: 1px solid var(--border-color);
            color: var(--primary-text-color);
            display: flex;
            gap: 15px;
            align-items: center;

            &:hover {
                background-color: rgba(0, 0, 0, 0.1);
            }
        }

        .control_button {
            border: 1px solid rgba(0, 0, 0, 0.3);
            border-radius: 50%;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            &:hover {
                background-color: rgba(0, 0, 0, 0.1);
            }
        }
    }
`;

export const CTAButton = styled.button`
    border: none;
    display: flex;

    --tw-ring-offset-color: hsl(var(--background));
    --tw-text-opacity: 1;
    color: hsl(0 0% 100% / var(--tw-text-opacity, 1));
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.25rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    --tw-bg-opacity: 1;
    background-color: hsl(265 89% 60% / var(--tw-bg-opacity, 1));
    border-radius: calc(var(--radius) - 2px);
    border-radius: 6px;
    white-space: nowrap;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
    height: 2.25rem;
    display: inline-flex;
    cursor: pointer;

    &:hover {
        background-color: hsl(265 89% 60% / 0.9);
    }
`;
